export default __webpack_public_path__ + "static/summit_stars_4_1-85129d0f87b1832c08f0bfdf92ecec27.svg";